module.exports = __webpack_public_path__ + "static/media/view4.0d042af2.jpg";